var workshopsList = [
    {
        "year": "2015",
        "yearWork": [
            {
                "data": `Hao Gao, M. Asif Naeem, Christof Lutteroth, and Gerald Weber. S3J: A Parallel Semi-Stream Similarity Join. Proceedings of 18th International Workshop On Data Warehousing and OLAP (DOLAP), ACM, 2015, (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1145/2811222.2811226`
            },
            
        ]
    },
    {
        "year": "2010",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gill Dobbie, Gerald Weber, “R-MESHJOIN for Near-Real Time Data Warehousing”, Proceedings of 13th International Workshop On Data Warehousing and OLAP (DOLAP), ACM, 2010. (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1145/1871940.1871952`
            },
        ]
    },
    {
        "year": "2009",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gill Dobbie, Gerald Weber, “Comparing Global Optimization and Default Settings of Stream-based Joins”, Proceedings of Business Intelligence for the Real Time Enterprise (BIRTE, VLDB Workshop), Springer-Verlag, 2009.`,
                "pdflink": `https://doi.org/10.1007/978-3-642-14559-9_10`
            },
        ]
    },
    {
        "year": "2008",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gill Dobbie, Gerald Weber, “An Event-Based Near Real-Time Data Integration Architecture”, Proceedings of International workshop on Middleware for Web Services, 2008.`,
                "pdflink": `https://core.ac.uk/download/pdf/56363102.pdf`
            },
        ]
    },
]
export default workshopsList;